function read(query, defaults) {
  return Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => {
    const raw = query[key];
    if (raw === undefined || raw === null || raw === '') return [key, fallback];
    if (typeof fallback === 'boolean') return [key, raw === '1' || raw === 'true'];
    if (typeof fallback === 'number') {
      const n = Number(raw);
      return [key, Number.isFinite(n) ? n : fallback];
    }
    return [key, String(raw)];
  }));
}

function write(state, defaults) {
  return Object.fromEntries(Object.entries(state)
    .filter(([key, value]) => key in defaults && value !== defaults[key] && value !== null && value !== undefined && value !== '' && value !== false)
    .map(([key, value]) => [key, value === true ? '1' : String(value)]));
}

function same(a, b) {
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
  return [...keys].every((k) => String(a[k] ?? '') === String(b[k] ?? ''));
}

export default function queryState(name, defaults) {
  return {
    data() {
      return { [name]: read(this.$route.query, defaults) };
    },
    created() {
      this.queryStateRoute = this.$route.name;
    },
    watch: {
      [name]: {
        deep: true,
        handler(state) {
          if (this.$route.name !== this.queryStateRoute) return;
          const others = Object.fromEntries(Object.entries(this.$route.query).filter(([key]) => !(key in defaults)));
          const query = { ...others, ...write(state, defaults) };
          if (!same(query, this.$route.query)) this.$router.replace({ query });
        },
      },
      '$route.query'(query) {
        if (this.$route.name !== this.queryStateRoute) return;
        const next = read(query, defaults);
        if (!same(next, this[name])) this[name] = next;
      },
    },
  };
}
